/* AmbassConnect · scroll-reveal for ambassador pages.
   Adds html.ac-motion and reveals cards/sections as they enter the viewport.
   Content stays visible without JavaScript or with reduced motion. */
(function () {
  'use strict';
  if (window.__acMotion) return;
  window.__acMotion = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ROOTS = '.ga-apply, .ga-program, .ga-public-network, .ga-network, .ga-directory';
  var TARGETS = [
    '[class*="__tier-card"]', '[class*="__card"]:not([class*="__card-"])', '.ga-network-card', '.ga-public-card', '.ga-ambassador-card',
    '[class*="__section-heading"]', '[class*="__intro"]', '[class*="__platform"]', '[class*="__public"]', '[class*="__privacy"]',
    '[class*="__fit"]', '[class*="__final"]', '.ga-network__stat', '.ga-apply__before', '.ga-apply__section'
  ].join(',');

  function setup(root) {
    var nodes = root.querySelectorAll(TARGETS);
    if (!nodes.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var groupIndex = new Map();
    nodes.forEach(function (node) {
      if (node.closest('[data-ac-reveal]') && node.closest('[data-ac-reveal]') !== node) return;
      var parent = node.parentElement;
      var i = groupIndex.get(parent) || 0;
      groupIndex.set(parent, i + 1);
      node.style.setProperty('--ac-i', String(Math.min(i, 6)));
      node.setAttribute('data-ac-reveal', '');
      io.observe(node);
    });
  }

  function boot() {
    var roots = document.querySelectorAll(ROOTS);
    if (!roots.length) return;
    document.documentElement.classList.add('ac-motion');
    roots.forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
